import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_2 = { class: "column pr-2 border-r" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Hero"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "The programmable web browser that's nearly impossible to block.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "ChromeAlive"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "The interactive tool that makes writing scraper scripts pure joy.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Datastore"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Package your data scripts as discrete, composable units ready to deploy.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Cloud"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Easily run and scale your Datastores across production and localhost.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Stream"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Integrate Ulixee's public and private datasets into your codebase.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-root" }, "Install Ulixee.app")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition ease-out duration-200",
    "enter-from-class": "opacity-0 translate-y-1",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-active-class": "transition ease-in duration-150",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PopoverPanel, { class: "absolute z-10 left-0 top-[100%] transform mt-3 px-2 w-screen max-w-4xl sm:px-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("ul", null, [
                _createVNode(_component_NavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/hero${_ctx.subPath}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/tool-icons/hero.svg')
                        }, null, 8, ["src"]),
                        _createTextVNode(),
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_NavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/chromealive${_ctx.subPath}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/tool-icons/chromealive.svg')
                        }, null, 8, ["src"]),
                        _createTextVNode(),
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_NavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/datastore${_ctx.subPath}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/tool-icons/datastore.svg')
                        }, null, 8, ["src"]),
                        _createTextVNode(),
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_NavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/cloud${_ctx.subPath}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/tool-icons/server.svg')
                        }, null, 8, ["src"]),
                        _createTextVNode(),
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_NavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: `/stream${_ctx.subPath}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('@/assets/tool-icons/stream.svg')
                        }, null, 8, ["src"]),
                        _createTextVNode(),
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createTextVNode(),
            _hoisted_8
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}